module.exports = __webpack_public_path__ + "img/limited-time-award-6.d6552cfa.png";